import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M18 4V0h2v4h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H0V3.192L12.371.54A3 3 0 0 1 16 3.474V4h2Zm-2 2v16h6v-3h-3v-2h3v-2h-3v-2h3v-2h-3V9h3V6h-6Zm-2 16V3.474a1 1 0 0 0-1.21-.978L2 4.808V22h3v-4h6v4h3Zm-5 0v-2H7v2h2ZM7 8H4V6h3v2Zm5 0H9V6h3v2Zm-5 4H4v-2h3v2Zm5 0H9v-2h3v2Zm-5 4H4v-2h3v2Zm5 0H9v-2h3v2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
